import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWrench } from "@fortawesome/free-solid-svg-icons";

import { log } from "utils/logger";

import "../css/Signature.css";

export default function Signature() {
  return (
    <a
      className="signature"
      href="https://twitter.com/rexbuilds"
      target="_blank"
      rel="noreferrer"
      onClick={() => log("twitter_signature_clicked")}
    >
      Built by <b>RexTheBuilder</b>
      {"  "}
      <FontAwesomeIcon icon={faWrench} />
    </a>
  );
}
